import { render } from "./SwpierTop.vue?vue&type=template&id=b4f23d4c"
import script from "./SwpierTop.vue?vue&type=script&lang=js"
export * from "./SwpierTop.vue?vue&type=script&lang=js"

import "./SwpierTop.vue?vue&type=style&index=0&id=b4f23d4c&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__